import { render, staticRenderFns } from "./exams-add.vue?vue&type=template&id=66f3b3d2"
import script from "./exams-add.vue?vue&type=script&lang=js"
export * from "./exams-add.vue?vue&type=script&lang=js"
import style0 from "./exams-add.vue?vue&type=style&index=0&id=66f3b3d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports